import React from "react";
import { Route } from "react-router-dom";
import POPManagerDashboard from "../../screens/pop_manager/POPManagerDashboard";
import AreaManagerList from "../../screens/pop_manager/AreaManagerList";
import AddAreaManager from "../../screens/pop_manager/AddAreaManager";
import CreateAreaProject from "../../screens/pop_manager/CreateAreaProject";
import AllPrograms from "../../screens/pop_manager/AllPrograms";
import CreateProgramForm from "../../screens/program_manager/CreateProgramForm";
import AddTask from "../../screens/program_manager/AddTask";
import ProgramDetails from "../../screens/program_manager/ProgramDetails";
import AreaManagerTargets from "../../screens/pop_manager/AreaManagerTargets";
import AreaProject from "../../screens/pop_manager/AreaProject";
import FranchiseManagement from "../../screens/pop_manager/FranchiseManagement";
import POPProgramsList from "../../screens/pop_manager/POPProgramsList";
import CreateProgram from "../../screens/pop_manager/CreateProgram";
import CreateStage from "../../screens/pop_manager/CreateStage";
import CreateActivity from "../../screens/pop_manager/CreateActivity";
import ProgramOrStageDetail from "../../screens/pop_manager/ProgramOrStageDetail";

export const popManagerRoutes = [
  <Route key="pop-manager-home" path="/" element={<POPManagerDashboard />} />,
  <Route
    key="pop-manager-area-managers"
    path="/pop-manager/area-managers"
    element={<AreaManagerList />}
  />,
  <Route
    key="pop-manager-area-manager-add"
    path="/pop-manager/area-manager/add"
    element={<AddAreaManager />}
  />,
  <Route
    key="pop-manager-area-project-list"
    path="/area-project-list"
    element={<AreaProject />}
  />,
  <Route
    key="pop-manager-area-project-add"
    path="/pop-manager/area-project/add"
    element={<CreateAreaProject />}
  />,

  <Route
    key="pop-manager-all-programs"
    path="/pop-manager/all-programs"
    element={<AllPrograms />}
  />,
  <Route
    key="pop-manager-program-list"
    path="/pop-manager/programs-list"
    element={<POPProgramsList />}
  />,
  <Route
    key="pop-manager-create-program"
    path="/pop-manager/create-program"
    element={<CreateProgram />}
  />,
  <Route
    key="pop-manager-stage-create"
    path="/pop-manager/program/:programId/create-stage/"
    element={<CreateStage />}
  />,
  <Route
    key="pop-manager-activity-create"
    path="/pop-manager/program/:programId/stage/:stageId/create-activity/"
    element={<CreateActivity />}
  />,
  <Route
    key="pop-manager-program-details"
    path="/pop-manager/program/:programId"
    element={<ProgramOrStageDetail type="program" />}
  />,
  <Route
    key="pop-manager-stage-details"
    path="/pop-manager/program/:programId/stage/:stageId"
    element={<ProgramOrStageDetail type="stage" />}
  />,

  <Route
    key="pop-manager-create-program"
    path="/pop-manager/create-program"
    element={<CreateProgramForm />}
  />,
  <Route
    key="pop-manager-add-tasks"
    path="/programs/:programId/add-tasks"
    element={<AddTask />}
  />,
  <Route
    key="pop-manager-program-details"
    path="/program/:programId"
    element={<ProgramDetails />}
  />,
  <Route
    key="pop-manager-area-manager-targets"
    path="/area-manager/:id"
    element={<AreaManagerTargets />}
  />,
  <Route
    key="pop-manager-franchise-management"
    path="/franchise-management/"
    element={<FranchiseManagement />}
  />,
  <Route
    key="pop-manager-edit-program"
    path="/pop-manager/create-program/:programId"
    element={<CreateProgramForm />}
  />,
];
